import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Cliente } from '../../../models/cliente.model';
import { ClienteFormService } from '../../../services/cliente-form.service';
import { ClienteSubmissionService } from '../../../services/cliente-submission.service';
import { LocationService } from '../../../services/location-service.service';
import { CountryService } from '../../../services/country-service.service';
import { Estado } from '../../../models/interfaces/estado.interface';
import { tipoLogradouros } from '../../../helpers/logradouro.helper';
import { FormatadorHelper } from '../../../helpers/formatador.helper';
import { IdentificacaoCpfCnpj } from '../../../models/enums/identificacao-cpf-cnpj.enum';
import { MapeamentoHelper } from '../../../helpers/mapeamentoObjeto.helper';
import { finalize } from 'rxjs';
import { SpinnerService } from '../../../services/spinner.service';
import { Icones } from '../../../shared/variaveisDeRotas';

@Component({
  selector: 'app-clientes-adicionar',
  templateUrl: './clientes-adicionar.component.html',
  styleUrls: ['./clientes-adicionar.component.scss'],
})
export class ClientesAdicionarComponent implements OnInit {
  @Output() addComplete = new EventEmitter<{ cliente: Cliente }>();
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  clienteForm: FormGroup;
  identificacaoCpfCnpj: string = '';
  readonly IdentificacaoCpfCnpjEnum = IdentificacaoCpfCnpj;
  readonly exemploCnpj = FormatadorHelper.EXEMPLO_CNPJ;
  maxCpfCnpjLength: number = 14;
  cpfCnpjEnabled: boolean = false;
  cpfCnpjLabel: string = 'CPF/CNPJ';
  ufEnabled: boolean = true;
  municipioEnabled: boolean = true;
  
  isExterior: boolean = false;
  showDocumentNumber: boolean = true;
  showUf: boolean = true;
  showMunicipio: boolean = true;
  showCep: boolean = true;
  isAddressRequired: boolean = true;

  paises: { label: string; value: string }[] = [];
  identificacoesCpfCnpjs: any[] = [
    { nome: 'CPF', tipo: IdentificacaoCpfCnpj.Cpf },
    { nome: 'CNPJ', tipo: IdentificacaoCpfCnpj.Cnpj },
    { nome: 'Exterior', tipo: IdentificacaoCpfCnpj.Exterior },
  ];

  estados: Estado[] = [];
  municipios: { label: string; value: string }[] = [];
  tipoLogradouros = tipoLogradouros;

  constructor(
    private fb: FormBuilder,
    private clienteFormService: ClienteFormService,
    private clienteSubmissionService: ClienteSubmissionService,
    private router: Router,
    private locationService: LocationService,
    private countryService: CountryService,
    public spinnerService: SpinnerService
  ) {
    this.clienteForm = this.clienteFormService.createForm();
    this.onChangeidentificacaoCpfCnpj(IdentificacaoCpfCnpj.Cnpj);
  }


  ngOnInit(): void {
    this.tituloChange.emit('Cadastro de Cliente');
    this.iconeChange.emit(Icones.usuarioAmarelo);
    this.InicializarDadosIBGE();
    this.clienteForm.get('tipoIdentificacaoCpfCnpj')?.enable();

  }
  onNomeRazaoSocialInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    this.clienteForm.get('apelido')?.setValue(value);
    this.clienteForm.get('razaoSocial')?.setValue(value);
  }


  onSubmit() {
    if (this.clienteForm.valid) {
      const nomeRazaoSocial = this.clienteForm.get('apelido')?.value;
      this.clienteForm.get('razaoSocial')?.setValue(nomeRazaoSocial);

      if (this.isExterior) {
        this.clienteForm.get('cpfCnpj')?.setValue(null);
        this.clienteForm.get('uf')?.setValue('EX');
        this.clienteForm.get('codigoMunicipio')?.setValue('99999');
        this.clienteForm.get('cep')?.setValue(null);
      } else {
        const formattedCpfCnpj = FormatadorHelper.normalizarDocumento(
          this.clienteForm.get('cpfCnpj')?.value || ''
        );
        this.clienteForm.get('cpfCnpj')?.setValue(formattedCpfCnpj);
      }

      const complementoValue = this.clienteForm.get('complemento')?.value;
      if (!complementoValue || complementoValue.trim() === '') {
        this.clienteForm.get('complemento')?.setValue('-');
      }

      const cliente = MapeamentoHelper.mapeaFormParaCliente(
        this.clienteForm.value
      );

      this.spinnerService.show('Salvando cliente...');

      this.clienteSubmissionService.submitCliente(
        cliente,
        (result) => {
          this.spinnerService.hide();
          this.addComplete.emit(result);
        },
        (error) => {
          this.spinnerService.hide();
          console.error('Erro ao salvar cliente', error);
        }
      );
    }
  }


  onCancel() {
    this.router.navigate(['/clientes']);
  }

  onChangeidentificacaoCpfCnpj(value: string) {
    this.identificacaoCpfCnpj = value;
    this.isExterior = value === IdentificacaoCpfCnpj.Exterior;

    this.clienteForm.get('cpfCnpj')?.setValue('');

    if (value === IdentificacaoCpfCnpj.Cpf) {
      this.cpfCnpjLabel = 'CPF';
      this.maxCpfCnpjLength = 14;
      this.showDocumentNumber = true;
      this.showUf = true;
      this.showMunicipio = true;
      this.showCep = true;
      this.isAddressRequired = true;

      this.clienteForm.get('cpfCnpj')?.enable();
      this.clienteForm.get('cpfCnpj')?.setValidators([
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(14),
      ]);
      this.clienteForm.get('cpfCnpj')?.setValue('');

      this.setAddressValidations(true);

    } else if (value === IdentificacaoCpfCnpj.Cnpj) {
      this.cpfCnpjLabel = 'CNPJ';
      this.maxCpfCnpjLength = 18;
      this.showDocumentNumber = true;
      this.showUf = true;
      this.showMunicipio = true;
      this.showCep = true;
      this.isAddressRequired = true;

      this.clienteForm.get('cpfCnpj')?.setValidators([
        Validators.required,
        Validators.minLength(18),
        Validators.maxLength(18),
      ]);

      if (!this.clienteForm.get('cpfCnpj')?.value) {
        this.clienteForm.get('cpfCnpj')?.setValue('');
      }

      this.clienteForm.get('cpfCnpj')?.enable();
      this.setAddressValidations(true);

    } else if (value === IdentificacaoCpfCnpj.Exterior) {
      this.cpfCnpjLabel = 'Número do Documento';
      this.maxCpfCnpjLength = 50;
      this.showDocumentNumber = false; 
      this.showUf = false; 
      this.showMunicipio = false; 
      this.showCep = false; 
      this.isAddressRequired = false; 

      this.clienteForm.get('cpfCnpj')?.enable();
      this.clienteForm.get('cpfCnpj')?.clearValidators();
      
      this.clienteForm.get('cpfCnpj')?.setValue(null);
      this.clienteForm.get('uf')?.setValue('EX');
      this.clienteForm.get('codigoMunicipio')?.setValue('99999');
      this.clienteForm.get('cep')?.setValue(null);
      
      this.setAddressValidations(false);
    }

    this.clienteForm.get('cpfCnpj')?.updateValueAndValidity();
  }
  onCpfCnpjInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const isCpf = this.identificacaoCpfCnpj === IdentificacaoCpfCnpj.Cpf;
    this.clienteForm.get('cpfCnpj')?.setValue(
      FormatadorHelper.aplicarMascaraDuranteInput(input.value, isCpf),
      { emitEvent: false }
    );
  }

  async InicializarDadosIBGE() {
    this.paises = this.countryService.getCountries();

    if (!this.clienteForm.get('pais')?.value) {
      this.clienteForm.get('pais')?.setValue('BR');
    }

    this.spinnerService.show('Carregando estados...');
    this.locationService
      .getEstados()
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe((estados) => {
        this.estados = estados
          .map((estado: any) => ({
            label: estado.sigla,
            value: estado.sigla,
            id: estado.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
      });

    this.clienteForm.get('uf')?.valueChanges.subscribe((ufSigla) => {
      const estado = this.estados.find((e) => e.value === ufSigla);
      if (estado) {
        this.spinnerService.show('Carregando municípios...');
        this.locationService
          .getMunicipiosPorUf(estado.id)
          .pipe(finalize(() => this.spinnerService.hide()))
          .subscribe((municipios) => {
            this.municipios = municipios
              .map((municipio: any) => ({
                label: municipio.nome,
                value: municipio.id,
              }))
              .sort((a, b) => a.label.localeCompare(b.label));
            this.clienteForm.get('municipio')?.setValue('');
          });
      }
    });

    this.clienteForm.get('municipio')?.valueChanges.subscribe((municipioId) => {
      const municipio = this.municipios.find((m) => m.value === municipioId);
      if (municipio) {
        this.clienteForm.get('codigoMunicipio')?.setValue(municipio.value);
        this.clienteForm.get('municipio')?.setValue(municipio.label);
      }
    });
  }

  getMask(): string {
    return this.identificacaoCpfCnpj === IdentificacaoCpfCnpj.Cpf
      ? FormatadorHelper.MASCARA_CPF
      : this.identificacaoCpfCnpj === IdentificacaoCpfCnpj.Cnpj
        ? FormatadorHelper.MASCARA_CNPJ
        : '';
  }

  setAddressValidations(isRequired: boolean) {
    if (isRequired) {
      this.clienteForm.get('logradouro')?.setValidators(Validators.required);
      this.clienteForm.get('numero')?.setValidators(Validators.required);
      this.clienteForm.get('bairro')?.setValidators(Validators.required);
      this.clienteForm.get('cep')?.setValidators(Validators.required);
    } else {
      this.clienteForm.get('logradouro')?.clearValidators();
      this.clienteForm.get('numero')?.clearValidators();
      this.clienteForm.get('bairro')?.clearValidators();
      this.clienteForm.get('cep')?.clearValidators();
    }

    this.clienteForm.get('logradouro')?.updateValueAndValidity();
    this.clienteForm.get('numero')?.updateValueAndValidity();
    this.clienteForm.get('bairro')?.updateValueAndValidity();
    this.clienteForm.get('cep')?.updateValueAndValidity();
  }

  onChangePais(selectedPais: string) {
    const isBrasil = selectedPais === 'BR';

    this.ufEnabled = isBrasil;
    this.municipioEnabled = isBrasil;

    if (!isBrasil) {
      this.clienteForm.get('uf')?.setValue('');
      this.clienteForm.get('codigoMunicipio')?.setValue('');
    }

    if (isBrasil) {
      this.clienteForm.get('uf')?.setValidators(Validators.required);
      this.clienteForm.get('codigoMunicipio')?.setValidators(
        Validators.required
      );
    } else {
      this.clienteForm.get('uf')?.clearValidators();
      this.clienteForm.get('codigoMunicipio')?.clearValidators();
    }

    this.clienteForm.get('uf')?.updateValueAndValidity();
    this.clienteForm.get('codigoMunicipio')?.updateValueAndValidity();
  }
}
